import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "C:/Users/ruffa/Documents/GitHub/learninghub/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const FeatureCard = makeShortcode("FeatureCard");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <FeatureCard title="Installing IBM Event-led solution using CP4I on IBM Cloud" color="dark" mdxType="FeatureCard">
      <span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "42.01388888888889%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAIABQDASIAAhEBAxEB/8QAFwABAAMAAAAAAAAAAAAAAAAAAAEDBP/EABYBAQEBAAAAAAAAAAAAAAAAAAMBAv/aAAwDAQACEAMQAAABywJqgQ//xAAZEAEAAgMAAAAAAAAAAAAAAAABAAIDEyH/2gAIAQEAAQUCMPGgmuf/xAAWEQEBAQAAAAAAAAAAAAAAAAAAEVH/2gAIAQMBAT8B1X//xAAVEQEBAAAAAAAAAAAAAAAAAAAQEf/aAAgBAgEBPwGH/8QAFxAAAwEAAAAAAAAAAAAAAAAAAAExIf/aAAgBAQAGPwKoxlR//8QAFxABAQEBAAAAAAAAAAAAAAAAAQARMf/aAAgBAQABPyFAbLAGcdj/2gAMAwEAAgADAAAAEIQf/8QAFxEAAwEAAAAAAAAAAAAAAAAAAAEhcf/aAAgBAwEBPxBTAh//xAAWEQEBAQAAAAAAAAAAAAAAAAABABH/2gAIAQIBAT8QyyX/xAAbEAEAAgIDAAAAAAAAAAAAAAABABExQSHB0f/aAAgBAQABPxCoxZtfIMKrh1UCuUXyp1P/2Q==')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "banner",
          "title": "banner",
          "src": "/learninghub/static/682036d1c67bdad1a6a2f7c86216fb93/2e753/install-cp4i-banner.jpg",
          "srcSet": ["/learninghub/static/682036d1c67bdad1a6a2f7c86216fb93/69549/install-cp4i-banner.jpg 288w", "/learninghub/static/682036d1c67bdad1a6a2f7c86216fb93/473e3/install-cp4i-banner.jpg 576w", "/learninghub/static/682036d1c67bdad1a6a2f7c86216fb93/2e753/install-cp4i-banner.jpg 1152w", "/learninghub/static/682036d1c67bdad1a6a2f7c86216fb93/6c77f/install-cp4i-banner.jpg 1195w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span>
    </FeatureCard>
    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">Lab Overview</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Prerequisites</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Installation Overview</AnchorLink>
  <AnchorLink mdxType="AnchorLink">1 - OpenShift Installation</AnchorLink>
  <AnchorLink mdxType="AnchorLink">2 – Clone Repositories</AnchorLink>
  <AnchorLink mdxType="AnchorLink">3 – Set Context</AnchorLink>
  <AnchorLink mdxType="AnchorLink">4 – Add the Catalog Sources</AnchorLink>
  <AnchorLink mdxType="AnchorLink">5 – Install the Operators</AnchorLink>
  <AnchorLink mdxType="AnchorLink">6 – Deploy the Platform UI</AnchorLink>
  <AnchorLink mdxType="AnchorLink">7 - Deploy Automation Assets</AnchorLink>
  <AnchorLink mdxType="AnchorLink">8 - Deploy API Connect</AnchorLink>
  <AnchorLink mdxType="AnchorLink">9 - Deploy App Connect</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Summary</AnchorLink>
    </AnchorLinks>
    <hr></hr>
    <h2>{`Lab Overview`}</h2>
    <p>{`A basic knowledge to deliver an Event-led Integration PoC is to know how to install IBM Event Automation solution. There are different deployment model of Event Automation, you can use Event Automation as part of Cloud Pak for Integration or as a standalone solution. In this document we will walk you through applying yaml and running scripts from the command line to install Event Automation on Cloud Pak for Integration. Having a good understand of interacting with your cluster from the CLI is essential when delivering a PoC.`}</p>
    <p>{`The first main goal of this session is to provide you the knowledge about how to install CP4I using command line interface from scratch. Here you will use a Openshift environment provided by TechZone team on IBM Cloud (VMware). However, you are welcome to use any supported OpenShift environment.`}</p>
    <p>{`The second goal is to provide some demo assets (based on Event Automation tutorials) to be ready to progress your PoC.`}</p>
    <p>{`In this session you will learn:`}</p>
    <ul>
      <li parentName="ul">{`how to install and configure a basic IBM Event-led integration solution by deploying CP4I using command line interface from scratch`}</li>
      <li parentName="ul">{`how to deploy Event Streams, Event Endpoint Management, Event Processing and MQ instances.`}</li>
    </ul>
    <hr></hr>
    <h2>{`Prerequisites`}</h2>
    <ul>
      <li parentName="ul">{`You need to have installed in your machine:`}
        <ul parentName="li">
          <li parentName="ul">
            <a href="https://docs.openshift.com/container-platform/4.8/cli_reference/openshift_cli/getting-started-cli.html" target="_blank">oc CLI</a> v4.6+.
          </li>
          <li parentName="ul">{`github CLI`}</li>
          <li parentName="ul">{`Bash Shell`}</li>
          <li parentName="ul">{`JAVA v8+`}</li>
          <li parentName="ul">
            <a href="https://www.ibm.com/docs/en/api-connect/10.0.x?topic=configuration-installing-toolkit" target="_blank">apic CLI</a>
          </li>
        </ul>
      </li>
    </ul>
    <p>{`Note some of the tools will be available after you deploy an instance of the capability you are working on. And you also need an account in the folllowing email service to configure APIC:`}</p>
    <ul>
      <li parentName="ul">
        <a href="https://mailtrap.io/" target="_blank">mailtrap</a>
      </li>
    </ul>
    <hr></hr>
    <h2>{`Installation Overview`}</h2>
    <p>{`A IBM Cloud Pak® for Integration installation consists of a Red Hat® OpenShift® Container Platform cluster with one or more Cloud Pak for Integration operators installed and one or more instances of Platform UI deployed.`}</p>
    <p>{`In this document, we will follow the steps below to install Event Automation on CP4I. If you need more details about the CP4I Installation process, please check the product documentation `}<a href="https://www.ibm.com/docs/en/cloud-paks/cp-integration/2022.4?topic=installing-overview-installation" target="_blank">{`here`}</a>{`.`}</p>
    <ul>
      <li parentName="ul">{`1 - OpenShift Installation`}</li>
      <li parentName="ul">{`2 - Access your OpenShift cluster`}</li>
      <li parentName="ul">{`3 – Clone Repositories`}</li>
      <li parentName="ul">{`4 – Set Context`}</li>
      <li parentName="ul">{`5 – Install Foundational Services`}</li>
      <li parentName="ul">{`6 – Deploy the Platform Navigator UI`}</li>
      <li parentName="ul">{`7 - Deploy Event Streams`}</li>
      <li parentName="ul">{`8 - Deploy Event Endpoint Management (EEM)`}</li>
      <li parentName="ul">{`9 - Deploy the Enterprise Messaging (MQ)`}</li>
      <li parentName="ul">{`10 - Deploy Event Processing`}</li>
    </ul>
    <hr></hr>
    <h2>{`1 - OpenShift Installation`}</h2>
    <p>{`IBM Cloud Pak for Integration brings together IBM’s market-leading middleware capabilities to support a broad range of integration styles and use cases. With powerful deployment, lifecycle management, and production services running on Red Hat OpenShift, it enables clients to leverage the latest agile integration practices, simplify the management of their integration architecture, and reduce cost. Cloud Pak for Integration demands an OpenShift cluster.`}</p>
    <p>{`Follow the steps below to provision a Red Hat OpenShift Container Platform cluster on VMware on IBM Cloud.`}</p>
    <p>{`1.1. To request an OpenShift Cluster on VMware on IBM Cloud, go `}<a href="https://techzone.ibm.com/my/reservations/create/63a3a25a3a4689001740dbb3" target="_blank">{`here`}</a>{` and complete the form with the follow details.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Field`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Value`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Purpose`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`If you are doing the L4 course, select `}<strong parentName="td">{`Practice/Self Enablement`}</strong>{`. `}<br />{` If you are delivering a PoC, select:`}<strong parentName="td">{`Proof-of-Concept`}</strong>{` and inform the Sales opportunity.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Purpose Description`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`If you are doing the L4 course, enter: `}<strong parentName="td">{`Event-led Integration L4 Course`}</strong>{`. `}<br />{` If you are delivering a POC, enter the PoC details.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Preferred Geography`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`You are welcome to select the preferred Geography`}</td>
        </tr>
      </tbody>
    </table>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.25%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAABwklEQVQoz42RzW7aQBSFJ5tGSoRIuuNFuuuqDxASSERSpaqa0m2eobsu80Z5A9hVCi1QMBhkPLaxPeMfcE7vHYQVIaTE0qe5Y1+fc39ErVbD6ckJqtWqoVKp4Pj4CAcHAkK8jXdHNRy+/4CPn64hvrd/4ObzLb7dtXFH3H75ilbrBs3mFernTZydnaNev8BF4xKNRoPeN0tarWtcXdbRvn/A/a/f+PnwCJGmOXSSQ+mUyBCrFJrO9RpYEWm2Rp4XKJ6BZ+Lls1wu4boSM9uCdP4h1QFEEPjwpITnSUjpwvc9KBWTqCrPbayUMsRxbLAsC3/7ffT+9GHPHYRRzIIBiXkIw7BMjCJF6PK+i9baMJ1OMRqNYE2mcKVH/0QbQcdxqLKgrCCMEyKjhNgY7bIVnZDQU69HghPqTiJNUwiuzp65cGQEL9CQhBeQKM2HHffBomzM87PtmcGnwrIsg9i0GBnH1WpFy1i/SlEUJnc+n2M8Hpvl5HQvBbetKqXLmMt/jcVigeFwiMFgQCPzjZGZIffPLhxvq00SJtnL5ntCLbs0x4nZQZ+2zbGZIQuyA8csvG8Ru0RRaFrm6li40+mg2+3iPxWk8ezKViozAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ocp install 1",
        "title": "ocp install 1",
        "src": "/learninghub/static/f5904a6dc9cf5097c533083c84f243eb/3cbba/ocp-install-1.png",
        "srcSet": ["/learninghub/static/f5904a6dc9cf5097c533083c84f243eb/7fc1e/ocp-install-1.png 288w", "/learninghub/static/f5904a6dc9cf5097c533083c84f243eb/a5df1/ocp-install-1.png 576w", "/learninghub/static/f5904a6dc9cf5097c533083c84f243eb/3cbba/ocp-install-1.png 1152w", "/learninghub/static/f5904a6dc9cf5097c533083c84f243eb/04501/ocp-install-1.png 1637w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Field`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Value`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`OpenShift Version`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`4.15`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`OCS/ODF Size`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`ODF - 2 TB`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Worker Node Count`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`5`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Worker Node Flavor`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`16 vCPU x 64 GB - 100 GB ephemeral storage`}</td>
        </tr>
      </tbody>
    </table>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "59.72222222222222%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAABKElEQVQoz52SW26DMBREvVAIROIjLKTt1potgFpIJJ7FmFd45CPTjCMiVFUVFGlAtq8PM74WruvicDjAtm04jqO13+9XabfbwTRNWJYFwzDw9voCcb1eMQwDbrcbtj5lWSJNUyRJAimlZoiqqlDXNZqmQdd1m0TQ6XTC+XzW4MvlAkFQ27Z60Pf9JkVRhCAINIymOCdmZxww+hrNtXToeR7CMESe5+DxPSP/x2FRFNodE07ThHEcH0CllJ6k0y0u2RTGJpjAZ2Q6nGOvFaFZlsH3fa04jh9NWTZk+fc1QF4VguiQbmlM8MUFTjD6Fqdlqe6RY/3lWDdlCVg65QH/JdaoUkLJL1RK6rvIKyQI+XnY3DB37Vdx7V4bJC0+0xGyA/yPEMfjO74BjrB6GOQWehMAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "ocp install 2",
        "title": "ocp install 2",
        "src": "/learninghub/static/7cc5c3a732963d2cfeda9dcdb06fb3a7/3cbba/ocp-install-2.png",
        "srcSet": ["/learninghub/static/7cc5c3a732963d2cfeda9dcdb06fb3a7/7fc1e/ocp-install-2.png 288w", "/learninghub/static/7cc5c3a732963d2cfeda9dcdb06fb3a7/a5df1/ocp-install-2.png 576w", "/learninghub/static/7cc5c3a732963d2cfeda9dcdb06fb3a7/3cbba/ocp-install-2.png 1152w", "/learninghub/static/7cc5c3a732963d2cfeda9dcdb06fb3a7/04501/ocp-install-2.png 1637w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <p>{`1.2 `}<strong parentName="p">{`Agree`}</strong>{` with the TechZone Terms and Conditions (A) and click `}<strong parentName="p">{`Submit`}</strong>{` (B).
`}<span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "59.72222222222222%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAABKElEQVQoz52SW26DMBREvVAIROIjLKTt1potgFpIJJ7FmFd45CPTjCMiVFUVFGlAtq8PM74WruvicDjAtm04jqO13+9XabfbwTRNWJYFwzDw9voCcb1eMQwDbrcbtj5lWSJNUyRJAimlZoiqqlDXNZqmQdd1m0TQ6XTC+XzW4MvlAkFQ27Z60Pf9JkVRhCAINIymOCdmZxww+hrNtXToeR7CMESe5+DxPSP/x2FRFNodE07ThHEcH0CllJ6k0y0u2RTGJpjAZ2Q6nGOvFaFZlsH3fa04jh9NWTZk+fc1QF4VguiQbmlM8MUFTjD6Fqdlqe6RY/3lWDdlCVg65QH/JdaoUkLJL1RK6rvIKyQI+XnY3DB37Vdx7V4bJC0+0xGyA/yPEMfjO74BjrB6GOQWehMAAAAASUVORK5CYII=')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "ocp install 2",
          "title": "ocp install 2",
          "src": "/learninghub/static/7cc5c3a732963d2cfeda9dcdb06fb3a7/3cbba/ocp-install-2.png",
          "srcSet": ["/learninghub/static/7cc5c3a732963d2cfeda9dcdb06fb3a7/7fc1e/ocp-install-2.png 288w", "/learninghub/static/7cc5c3a732963d2cfeda9dcdb06fb3a7/a5df1/ocp-install-2.png 576w", "/learninghub/static/7cc5c3a732963d2cfeda9dcdb06fb3a7/3cbba/ocp-install-2.png 1152w", "/learninghub/static/7cc5c3a732963d2cfeda9dcdb06fb3a7/04501/ocp-install-2.png 1637w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span></p>
    <p>{`1.3 You will receive an email confirming the instance is provisioning.
`}<span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "59.72222222222222%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAABmElEQVQoz52TXUsCQRiF528Koigi+Euq39BtCF0VdRNdpXkhgtBFYuTHhhuouzv74X7Prp7mHRGsqLSFwyyzM2ee9+w7rNFogFStVlGv11Gr1dT7X6pUKigWiygUCiiVSiiXyzg7PQETQiDPc/zn8TwPuq7DMAyEYajmmG3bcBwHvu8jCIKjZJom5vO52k+GSZKAua4LMt0ZxnGMKIoOEhnOZjNwzpUZVctWq5VCJ7NDjUh0MJU6Ho+ViDRNUzAiI1xaRKfsCOMDDImMjIiUc0v5MKKjD7ssjyGlfbr+Lvc6oEpVhvs/w/flGBJdjEQSEAUt2tdujkbX4XC4CctcytjcLWGWZXuNsJGKkK0FkiyXmSTfDEmUFR2oLXzMLAHDFUjFems4GAzQbrfR63XRfezj/sHC27MGf/qqyqAKvormwyiANuIYPS1gTz1sYsh+zsA6nQ6azSZubq9xdXmH84slhn0Nsce3EfzSh77M3DMt5ImAbXFMJhOwT7dkI8vPXVmOJJH4QfBzs6vsaY1UKlIMX4ZotVr4AN85dKFWKYwVAAAAAElFTkSuQmCC')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "ocp install 3",
          "title": "ocp install 3",
          "src": "/learninghub/static/36c85925ed9f1bb0f52da36811cd79bb/3cbba/ocp-install-3.png",
          "srcSet": ["/learninghub/static/36c85925ed9f1bb0f52da36811cd79bb/7fc1e/ocp-install-3.png 288w", "/learninghub/static/36c85925ed9f1bb0f52da36811cd79bb/a5df1/ocp-install-3.png 576w", "/learninghub/static/36c85925ed9f1bb0f52da36811cd79bb/3cbba/ocp-install-3.png 1152w", "/learninghub/static/36c85925ed9f1bb0f52da36811cd79bb/04501/ocp-install-3.png 1637w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span></p>
    <p>{`1.4 You will receive a second email once the environment is provisioned. You should expect this to take between 30 and 120 minutes. Now the status update changed to `}<strong parentName="p">{`Ready`}</strong>{`.  Click on `}<strong parentName="p">{`Reservation ID`}</strong>{` to open the details page of your new reservation environment.
`}<span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "76.04166666666667%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAYAAADkmO9VAAAACXBIWXMAABYlAAAWJQFJUiTwAAADE0lEQVQ4y42TW28bVRSF/VI1NY2T2o1vMdiJ7dhJTWXAStUEKlDFRYmSByRa16XqhQfaqBVFAgmJB5B4plRcGvLCz+BX0Ig0JG1Jq9DUiS/jsWfscWJ7Lh/HkwohUSWMtLTOmTn6tPbZsx3pdJpoNEoikWQoPEj/4QO88vIIJ15LkU7F7fXxsSivHk8wNhImlRyy15EXvRxxHSQeGyY5OkooFCKbzeKIRCK43R68A0dxDURxHIzTH57EM3yK3tAER2Nv4h46RXD0HQLJt8W7k3hHTtPjy+DoiePxhfH7vDidTqanp3HEYjG8vgB+zyEG311g+HMYnDNJfwGvf92VxeRXFuNfmra/9Q3EPjEJzVm8dFOczXxE0NuHq6+fmZkZHN1yff6AiN/DeHaexXWLu6sFFh9IrKyrLD9WhGr/8hpLjxT+fFLl1yUIj18hMOD6L7C/t4fJ8z9TrXeQSxvIUgG93QQMIf2ZOrt7s2Pv7xe7wMt7AD9cYG2jxsofy6zef0CxVEZRVKrV2q7XFDStKVwVwDZL+X2AE+fn2azDRqnKVlVDaVnITZ2KplNu6EiaIdaG7d2k9/L/I+FfW3UerT1ErddRVZWaotiuCpdl+Z+kLU1m8QlETlzBv9cddoGrK/fI5/NI5TLFYlGoQFGSBVixpRsW3Wd5c7+Sc/PURB/kSplKRaZUlpCEVySJiqKhiivY3mnRaGiiL3V+W98n4YRIWKrpAiRg1Tab0jaFyg5as0W73abRMgWwbTcGXePunkDXIU6KhNuiGtPUMUxLuGnLMEx7b1ldiXaY2E35/elzSu5Oij8QtIFvXFhAbbQoPX1IpbzJVqlAWereYR5V3rJTWZ0Geqtu/4dr0m7CgJiUvr4jzM7OPptlzwDu3gNE3vuJc3cge6vJ2dsdznxvkf3BIvejybnbO5z9bocz327zgdClOzqzt8CfvojX7cT5wmGmpqZwZDIZEskxxuKDjL7/C4EbELhqELhm4b9qEb9pcewzi5SY8ZFPxbdrEJwD38cGweuQOn2DY4kI4cgwuVyOvwEICv3Oq6DmeQAAAABJRU5ErkJggg==')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "ocp install 4",
          "title": "ocp install 4",
          "src": "/learninghub/static/b794d497cbecb0f2b01065010b590d4d/3cbba/ocp-install-4.png",
          "srcSet": ["/learninghub/static/b794d497cbecb0f2b01065010b590d4d/7fc1e/ocp-install-4.png 288w", "/learninghub/static/b794d497cbecb0f2b01065010b590d4d/a5df1/ocp-install-4.png 576w", "/learninghub/static/b794d497cbecb0f2b01065010b590d4d/3cbba/ocp-install-4.png 1152w", "/learninghub/static/b794d497cbecb0f2b01065010b590d4d/0b124/ocp-install-4.png 1728w", "/learninghub/static/b794d497cbecb0f2b01065010b590d4d/fea76/ocp-install-4.png 1866w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span></p>
    <p>{`1.5 Copy your `}<strong parentName="p">{`Cluster Admin Username`}</strong>{` (A) and `}<strong parentName="p">{`Cluster Admin Password`}</strong>{` (B). Copy the `}<strong parentName="p">{`OCP Console link`}</strong>{` (C).
`}<span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "82.29166666666666%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAQCAYAAAAWGF8bAAAACXBIWXMAABYlAAAWJQFJUiTwAAACwklEQVQ4y62SSW/UQBCFfeMXsdz4EfwZ1hNXBIcQDhwShBSQgliEEBAEVy6IrB5PZuI1s8ceb7PYbbvrUT0YMgMSJ6z59Hqk7tevq0rTNC1h8J841S5cfR5pF7egXX5GK1xZ0mX+3Hd5i7RLW5IB42nX1hDffQvcegm6/Qq4+QK4odiu19vnXN9e/a/23Xm9QNbqaZtfpjGmFvxem1LfBnIfEAFQMMKvtUZGQBXVGgKUACgVslZPW3ufxZHfheP1yPU6CKNkQRSnGIfxQtPJHHEyhST2kasUlYIko5QNP+Tx6KyPljsgpzdCmlWYCsKkJsklskJyBj7AQUo+KIlAS/Ana/W09Z0y9qMxDPeMBnGGMCOMJiWGaYFwVi7MxMJIrhip75cqw1o97dFHESdhH1EyJSEKzOdzZKzqCZX86yDUkv6Z8EMWB30TbndIXT9GN5gg4BrKqoKUP03VM6dCIuFyLJufX0LnCZVhOHLRbFvUMm0c91O4EyAQwDgHYjZJ8wrRvII/LRflCFj5Esq5sPUrZJ3W0x6+n8fBgI1aJ2SZJ2Q7HXIOmmTtHtGZ0yVORjm/Xx3mWtIsryialzQTFXFiKlS3sJRQGfZdA/v7B3TUtrB3cExf33yig3c75HzbJz/jlDlhxuMRc+owB02KBeCgKNSTOeHvsXnITRn6I+hmj/TvOjV2DTJ0l1oNh5pHNlmGTU7TYWw6adjU0m0YhxZYqc0MTZfSaFI6YwEzEKqG+Tj0T3FiOmV7T6+cQ0N6RwbZhw3q6Ab1dL1iysFxuxy1zXzYMme9Y1MM2laliC2rEuOglFKqpI5qivC5y3qjCdM00el0xp1ul3/dfq8/6ERRhDRNMM/FYh4rnsefnf7FSr/PtMefq3Uge5Kks408zzdFUa7xEN/n7j3gct/nXY+ZJ8wGs1mvN2kZog3mKd9z7wed6UlXfIi8VQAAAABJRU5ErkJggg==')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "ocp install 5",
          "title": "ocp install 5",
          "src": "/learninghub/static/375847b7c50754567d9589c0bd026f97/3cbba/ocp-install-5.png",
          "srcSet": ["/learninghub/static/375847b7c50754567d9589c0bd026f97/7fc1e/ocp-install-5.png 288w", "/learninghub/static/375847b7c50754567d9589c0bd026f97/a5df1/ocp-install-5.png 576w", "/learninghub/static/375847b7c50754567d9589c0bd026f97/3cbba/ocp-install-5.png 1152w", "/learninghub/static/375847b7c50754567d9589c0bd026f97/0b124/ocp-install-5.png 1728w", "/learninghub/static/375847b7c50754567d9589c0bd026f97/6c456/ocp-install-5.png 1878w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span></p>
    <hr></hr>
    <h2>{`2 - Access your OpenShift cluster`}</h2>
    <p>{`In this section, you access your OpenShift cluster and install the OpenShift command line tool.`}</p>
    <p>{`2.1 In a Browser, open the OCP Console link and paste the `}<strong parentName="p">{`Cluster Admin Username`}</strong>{` (A) and `}<strong parentName="p">{`Password`}</strong>{` (B) copied in the previous step and click `}<strong parentName="p">{`Log in`}</strong>{` (C).
`}<span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "57.29166666666667%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAABYlAAAWJQFJUiTwAAABzklEQVQoz3WTW0sbURSFJ/fLzOSeTIS+BtMmSJIHrz9SpMRY1BbzINgEpL+hr0X0VUUa6sMIgndR08lyr1NnnAk0sDhnLvnO2nuv0crlMkqlkhL3lUolIMuyYBgGYvE40rqOaCyGmEiXfaFQwPT/NfcG13w+j0wm4ymbzSqYpmkIhcMBaaEQwpEITHnPD1VAqlgsolarodPpoNVqod1uKzUajX8nEyJgF0QRTMeuIQ/I0ljCeq+H27s7/B6NMBLZto3xeIyNzU3oAvtQrSKRSnlQArn6S1dA9on96e/sgL/nxwc4joPJZKKu9wYDmAJs1uso0u2US7aHpt6BdCi92t7o4fHsGA/nI8D5i6eXFwUcDodIyvOUHJpIJr0eUtwbphkcivVW8rftr7i0r3FydIzTUxt/Lu5x4wC7e0MY8pyVsLxcLqeGQbH3pgAj0ah69tZDC6ahY637Bd8P79HdP8Ln/k/0f/zC4OAKq90tNRBWkZMkEOJOlXDGiG7jEq3AlOvSo5WlBSwvzmNZ1rm5Jj59nEV1ZsYrzx0EHVH+e6oV/hzyNMMwA2Kg/VP9n/hOkgnwh3L6K6GqEhWuPIxJiCcSKnt0p5yKeJ1OpxXjFWw6UTPFqG7OAAAAAElFTkSuQmCC')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "oc cli 1",
          "title": "oc cli 1",
          "src": "/learninghub/static/cb93f76adcdb7c27c6fa8518aa319883/3cbba/oc-cli-1.png",
          "srcSet": ["/learninghub/static/cb93f76adcdb7c27c6fa8518aa319883/7fc1e/oc-cli-1.png 288w", "/learninghub/static/cb93f76adcdb7c27c6fa8518aa319883/a5df1/oc-cli-1.png 576w", "/learninghub/static/cb93f76adcdb7c27c6fa8518aa319883/3cbba/oc-cli-1.png 1152w", "/learninghub/static/cb93f76adcdb7c27c6fa8518aa319883/0b124/oc-cli-1.png 1728w", "/learninghub/static/cb93f76adcdb7c27c6fa8518aa319883/4ea69/oc-cli-1.png 2304w", "/learninghub/static/cb93f76adcdb7c27c6fa8518aa319883/fb7bd/oc-cli-1.png 3456w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span></p>
    <p>{`2.2 Great, you are almost ready for the demo. Last but not least important, let’s copy login command to access the cluster by CLI. On the top right, click your `}<strong parentName="p">{`username`}</strong>{` (A) and select `}<strong parentName="p">{`Copy login command`}</strong>{` (B).
`}<span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "57.29166666666667%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAABYlAAAWJQFJUiTwAAACPklEQVQoz11SyW4TQRScjyBxvBAFsjjBcUwWCAIhJAQSglhw5cIFIfEDHDjxExyQcOIkXPkhTqDEwXacGU/3LL1MzxSv25FlYak0o+r3qqtq7JXm5rG0uIRqtYJa8zHmdl7jRusl4RVK2weo7B6gPIPqXtvBvtfuv8H8Thvv3r7Ht8+f8OXDR3jPXrTx5Olz7D94iK/HP/HLB36HwB8GnHHgbwxczKCfTGD5XkSzNBdwhVwk0DKDd2//EVrbe7i1vIaT0x8ACohojEKnQK4BIwmK3q9hZmDPCw1jNJTOkCQJvEbzLuobm5hfqKJz2IXMgVHAIKWCzgxMniNNFaJI0IIkLnNcpiRkwiHTGBlxuZtLJ4Jr6w0sVG6ie3wK+2OMuwFjDIqiILEYV1e+e2qtHadIMI44zWTTOSEEvM2tbazW7zjBo+6JExzzhCJMhix4IhDyGJIWrBsiIZUmXiFVBpnJ3dzUYaPZQrm6SJGPnKC9SeocSUpCLHSczqgnWwG5ScmdyiiikODcpjHujFMCr9nawRbBOrSCvu+j1+tRvIgWUgQRc4KxTMHFpL8xle8uofh2zj6zvKDLOTz7dZdX11Eq1/C9cwgWC1z6jDqir0euwmCEwWDo4ti+7LKh2NZhkqS4DEOqgyOmWsYhg3d7pY6VtY2poF0MgsB1YqP4owHOyTFjDEJKdy7IuRUUVMkZJTrv98GsMOE/wQ5FvsRZ74I6o6KvBQfDoROUJGj7VUpBmcK5HRA/pH9AHMcO/wAVa9bxALU+tAAAAABJRU5ErkJggg==')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "oc cli 2",
          "title": "oc cli 2",
          "src": "/learninghub/static/dd28805a60c6e2eef8f91041fdbb598c/3cbba/oc-cli-2.png",
          "srcSet": ["/learninghub/static/dd28805a60c6e2eef8f91041fdbb598c/7fc1e/oc-cli-2.png 288w", "/learninghub/static/dd28805a60c6e2eef8f91041fdbb598c/a5df1/oc-cli-2.png 576w", "/learninghub/static/dd28805a60c6e2eef8f91041fdbb598c/3cbba/oc-cli-2.png 1152w", "/learninghub/static/dd28805a60c6e2eef8f91041fdbb598c/0b124/oc-cli-2.png 1728w", "/learninghub/static/dd28805a60c6e2eef8f91041fdbb598c/4ea69/oc-cli-2.png 2304w", "/learninghub/static/dd28805a60c6e2eef8f91041fdbb598c/fb7bd/oc-cli-2.png 3456w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span></p>
    <p>{`2.3 Click `}<strong parentName="p">{`Display Token`}</strong>{`.
`}<span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "6.944444444444445%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAABCAYAAADeko4lAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAKElEQVQI12N4fe32//unrv//cPv2/5/fv///8fPn/x8/fvz/CaTJwQAWCk1CNpeAGwAAAABJRU5ErkJggg==')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "oc cli 3",
          "title": "oc cli 3",
          "src": "/learninghub/static/d8cc4498d9f303de623eb835d1aebfe1/3cbba/oc-cli-3.png",
          "srcSet": ["/learninghub/static/d8cc4498d9f303de623eb835d1aebfe1/7fc1e/oc-cli-3.png 288w", "/learninghub/static/d8cc4498d9f303de623eb835d1aebfe1/a5df1/oc-cli-3.png 576w", "/learninghub/static/d8cc4498d9f303de623eb835d1aebfe1/3cbba/oc-cli-3.png 1152w", "/learninghub/static/d8cc4498d9f303de623eb835d1aebfe1/0b124/oc-cli-3.png 1728w", "/learninghub/static/d8cc4498d9f303de623eb835d1aebfe1/4ea69/oc-cli-3.png 2304w", "/learninghub/static/d8cc4498d9f303de623eb835d1aebfe1/b4847/oc-cli-3.png 2412w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span></p>
    <p>{`2.4 Copy the `}<strong parentName="p">{`Log in with this token command`}</strong>{` and `}<strong parentName="p">{`paste`}</strong>{` on a terminal window.
`}<span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "27.430555555555557%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAFCAYAAABFA8wzAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAu0lEQVQY06XQwQ6DIAwGYN//8Wa2JWZxKupEFIqii+7wr6Az2a47fNCWphAiQwZCCBijYYk2lkBcH8cR67oGr916WLAsjOOw7yKZZUhOMdLLFbIQkHnBRKBEGbTMn7WFOPKurEB1DccPcPMTzk2Yed8GxucgT26o7zmqNAseHHu/NZ83WQHFFxjVgwYHsgNGHhoNvLSdgVQaShPafiO51jAfK22h9tonDz2+d497Y+GmGZHWC7T+/od/vAEQUXqOWtYE7gAAAABJRU5ErkJggg==')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "oc cli 4",
          "title": "oc cli 4",
          "src": "/learninghub/static/47e11524c687b4dae605a04616e7233f/3cbba/oc-cli-4.png",
          "srcSet": ["/learninghub/static/47e11524c687b4dae605a04616e7233f/7fc1e/oc-cli-4.png 288w", "/learninghub/static/47e11524c687b4dae605a04616e7233f/a5df1/oc-cli-4.png 576w", "/learninghub/static/47e11524c687b4dae605a04616e7233f/3cbba/oc-cli-4.png 1152w", "/learninghub/static/47e11524c687b4dae605a04616e7233f/0b124/oc-cli-4.png 1728w", "/learninghub/static/47e11524c687b4dae605a04616e7233f/4ea69/oc-cli-4.png 2304w", "/learninghub/static/47e11524c687b4dae605a04616e7233f/fb7bd/oc-cli-4.png 3456w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span></p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "984px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "13.88888888888889%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAADCAYAAACTWi8uAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAZUlEQVQI15XM6wYAIRAF4N7/GYtIlOimC0lnzdCyP/fwcWaMEUopaK0ZdSklc84xa+2HMebtIQR47xFjRGsNpRQIGi5akForH5AxBptzfnrvHWstnHPYjUgpIefMj+7h3ht/cx8/P6bmGsvyP10AAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "oc cli 4 2",
        "title": "oc cli 4 2",
        "src": "/learninghub/static/596d877e56382ff0981cfbfd5f086a20/2200d/oc-cli-4-2.png",
        "srcSet": ["/learninghub/static/596d877e56382ff0981cfbfd5f086a20/7fc1e/oc-cli-4-2.png 288w", "/learninghub/static/596d877e56382ff0981cfbfd5f086a20/a5df1/oc-cli-4-2.png 576w", "/learninghub/static/596d877e56382ff0981cfbfd5f086a20/2200d/oc-cli-4-2.png 984w"],
        "sizes": "(max-width: 984px) 100vw, 984px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <p>{`That is it! Now you are ready for the Cloud Pak for Integration installation. Take a breath and let’s start to install the Pak.`}</p>
    <hr></hr>
    <h2>{`3 - Clone Repositories`}</h2>
    <p>{`To use this guide you will need to clone the demo repo to your workstation. Let’s do it now!`}</p>
    <p>{`3.1 Open a terminal window and `}<strong parentName="p">{`run`}</strong>{` the command below.`}</p>
    <pre><code parentName="pre" {...{}}>{`gh repo clone github.ibm.com/joel-gomez/cp4i-demo
`}</code></pre>
    <p>{`3.2 Open the `}<strong parentName="p">{`cp4i-demo`}</strong>{` folder.`}</p>
    <pre><code parentName="pre" {...{}}>{`cd cp4i-demo
`}</code></pre>
    <hr></hr>
    <h2>{`4 - Set Context`}</h2>
    <p>{`Based on where you have deployed your OCP cluster you will need to set up some environment variables to inform the installation script about your environment. Let’s do it here!`}</p>
    <p>{`4.1 First, you need to define an environment variable to inform CP4I version.`}</p>
    <pre><code parentName="pre" {...{}}>{`export CP4I_VER=16.1.0
`}</code></pre>
    <p>{`4.2 Now let’s set the OCP type based on the storage classes in your cluster.`}</p>
    <pre><code parentName="pre" {...{}}>{`export OCP_TYPE=ODF
`}</code></pre>
    <p><inlineCode parentName="p">{`Note`}</inlineCode>{`: If you are using ROKS cluster, use export OCP_TYPE=ROKS.`}</p>
    <p>{`4.3 Set mailtap credentials.`}</p>
    <pre><code parentName="pre" {...{}}>{`export MAILTRAP_USER=<my-mailtrap-user>
export MAILTRAP_PWD=<my-mailtrap-pwd>
`}</code></pre>
    <p>{`4.4 If you have provisioned your OCP cluster in Tech Zone you can use the following script to set the proper default storage class.`}</p>
    <pre><code parentName="pre" {...{}}>{`scripts/99-odf-tkz-set-scs.sh
`}</code></pre>
    <p>{`4.5 Your cluster will also need access to pull the container software required to deploy the Cloud Pak. Your Entitlement Key is used to grant access. You can download you entitlement key from My IBM. Click Copy.`}</p>
    <p>{`4.6 The IBM Entitled Registry contains software images for the capabilities in IBM Cloud Pak® for Integration. To allow the Cloud Pak for Integration operators to automatically pull those software images, you must first obtain your entitlement key, then add your entitlement key in a pull secret. Replace the my-key with your IBM entitlement key.`}</p>
    <pre><code parentName="pre" {...{}}>{`export ENT_KEY=<my-key>
`}</code></pre>
    <p>{`4.7 Now, you need a namespace where you will deploy the different capabilities.`}</p>
    <pre><code parentName="pre" {...{}}>{`scripts/02a-cp4i-ns-key-config.sh
`}</code></pre>
    <hr></hr>
    <h2>{`5 - Install Foundational Services`}</h2>
    <p>{`The IBM Cloud Pak foundational services operator is no longer installed automatically. Install this operator manually if you need to create an instance that uses identity and access management. That is exactly, what you will do in this section.`}</p>
    <p>{`5.1 First you need to have a certificate manager, otherwise, the IBM Cloud Pak foundational services operator installation will not complete. Let’s do it!`}</p>
    <pre><code parentName="pre" {...{}}>{`oc apply -f resources/00-cert-manager-namespace.yaml
oc apply -f resources/00-cert-manager-operatorgroup.yaml
oc apply -f resources/00-cert-manager-subscription.yaml
`}</code></pre>
    <p>{`5.2 Confirm the subscription has been completed successfully before moving to the next step running the following command.`}</p>
    <pre><code parentName="pre" {...{}}>{`SUB_NAME=$(oc get deployment cert-manager-operator-controller-manager -n cert-manager-operator --ignore-not-found -o jsonpath='{.metadata.labels.olm\\.owner}');if [ ! -z "$SUB_NAME" ]; then oc get csv/$SUB_NAME -n cert-manager-operator --ignore-not-found -o jsonpath='{.status.phase}';fi;echo
`}</code></pre>
    <p>{`You should get a response like this:`}</p>
    <pre><code parentName="pre" {...{}}>{`Succeeded
`}</code></pre>
    <p>{`5.3 Now, you need to install Postgress SQL Catalog Source.`}</p>
    <pre><code parentName="pre" {...{}}>{`oc apply -f catalog-sources/\${CP4I_VER}/01-postgress-sql-catalog-source.yaml
`}</code></pre>
    <p>{`5.4 Confirm the catalog source has been deployed successfully before moving to the next step running the following command.`}</p>
    <pre><code parentName="pre" {...{}}>{`oc get catalogsources cloud-native-postgresql-catalog -n openshift-marketplace -o jsonpath='{.status.connectionState.lastObservedState}';echo
`}</code></pre>
    <p>{`You should get a response like this:`}</p>
    <pre><code parentName="pre" {...{}}>{`READY
`}</code></pre>
    <p>{`5.5 Ok, now you need to install Common Services Catalog source.`}</p>
    <pre><code parentName="pre" {...{}}>{`oc apply -f catalog-sources/\${CP4I_VER}/02-common-services-catalog-source.yaml
`}</code></pre>
    <p>{`5.6 Confirm the catalog source has been deployed successfully before moving to the next step running the following command:`}</p>
    <pre><code parentName="pre" {...{}}>{`oc get catalogsources opencloud-operators -n openshift-marketplace -o jsonpath='{.status.connectionState.lastObservedState}';echo
`}</code></pre>
    <p>{`You should get a response like this:`}</p>
    <pre><code parentName="pre" {...{}}>{`READY
`}</code></pre>
    <p>{`5.7 Create the Common Services namespace.`}</p>
    <pre><code parentName="pre" {...{}}>{`oc new-project ibm-common-services
`}</code></pre>
    <p>{`5.8 Now, let’s intall the Foundational Services operator (former Common Services).`}</p>
    <pre><code parentName="pre" {...{}}>{`oc apply -f subscriptions/\${CP4I_VER}/00-common-service-subscription.yaml
`}</code></pre>
    <p>{`5.9 Confirm the operator has been deployed successfully before moving to the next step running the following command:`}</p>
    <pre><code parentName="pre" {...{}}>{`SUB_NAME=$(oc get deployment/ibm-common-service-operator -n openshift-operators --ignore-not-found -o jsonpath='{.metadata.labels.olm\\.owner}');if [ ! -z "$SUB_NAME" ]; then oc get csv/$SUB_NAME --ignore-not-found -o jsonpath='{.status.phase}';fi;echo
`}</code></pre>
    <p>{`You should get a response like this:`}</p>
    <pre><code parentName="pre" {...{}}>{`Succeeded
`}</code></pre>
    <hr></hr>
    <h2>{`6 - Deploy the Platform UI`}</h2>
    <p>{`Deploying the Platform UI allows you to deploy and manage instances from a central location.`}</p>
    <p>{`6.1 First, let’s install Platform UI Catalog source.`}</p>
    <pre><code parentName="pre" {...{}}>{`oc apply -f catalog-sources/\${CP4I_VER}/03-platform-navigator-catalog-source.yaml
`}</code></pre>
    <p>{`6.2 Confirm the catalog source has been deployed successfully before moving to the next step running the following command.`}</p>
    <pre><code parentName="pre" {...{}}>{`oc get catalogsources ibm-integration-platform-navigator-catalog -n openshift-marketplace -o jsonpath='{.status.connectionState.lastObservedState}';echo
`}</code></pre>
    <p>{`You should get a response like this:`}</p>
    <pre><code parentName="pre" {...{}}>{`READY
`}</code></pre>
    <p>{`6.3 Now, let’s install the Platform UI Operator.`}</p>
    <pre><code parentName="pre" {...{}}>{`oc apply -f subscriptions/\${CP4I_VER}/01-platform-navigator-subscription.yaml
`}</code></pre>
    <p>{`6.4 Confirm the operator has been deployed successfully before moving to the next step running the following command.`}</p>
    <pre><code parentName="pre" {...{}}>{`SUB_NAME=$(oc get deployment ibm-integration-platform-navigator-operator -n openshift-operators --ignore-not-found -o jsonpath='{.metadata.labels.olm\\.owner}');if [ ! -z "$SUB_NAME" ]; then oc get csv/$SUB_NAME --ignore-not-found -o jsonpath='{.status.phase}';fi;echo
`}</code></pre>
    <p>{`You should get a response like this:`}</p>
    <pre><code parentName="pre" {...{}}>{`Succeeded
`}</code></pre>
    <p>{`6.5 Let’s deploy a Platform UI instance.`}</p>
    <pre><code parentName="pre" {...{}}>{`oc apply -f instances/\${CP4I_VER}/common/01-platform-navigator-instance.yaml
`}</code></pre>
    <p>{`6.6 Confirm the instance has been deployed successfully before moving to the next step running the following command.`}</p>
    <pre><code parentName="pre" {...{}}>{`oc get platformnavigator cp4i-navigator -n tools -o jsonpath='{.status.conditions[0].type}';echo
`}</code></pre>
    <p>{`You should get a response like this:`}</p>
    <pre><code parentName="pre" {...{}}>{`Ready
`}</code></pre>
    <p>{`6.7 Once the Platform UI instance is up and running get the access info.`}</p>
    <pre><code parentName="pre" {...{}}>{`scripts/03b-cp4i-access-info.sh
`}</code></pre>
    <p>{`6.8 Open the Platform UI URL and log in. Note the password is temporary and you will be required to change it. Take note of your new password, you will use it multiple times.`}</p>
    <hr></hr>
    <h2>{`7 - Deploy Event Streams`}</h2>
    <p>{`7.1 First, let’s intall the Event Streams Catalog Source.`}</p>
    <pre><code parentName="pre" {...{}}>{`oc apply -f catalog-sources/\${CP4I_VER}/08-event-streams-catalog-source.yaml
`}</code></pre>
    <p>{`7.2 Confirm the catalog source has been deployed successfully before moving to the next step running the following command.`}</p>
    <pre><code parentName="pre" {...{}}>{`oc get catalogsources ibm-eventstreams-catalog -n openshift-marketplace -o jsonpath='{.status.connectionState.lastObservedState}';echo
`}</code></pre>
    <p>{`You should get a response like this:`}</p>
    <pre><code parentName="pre" {...{}}>{`READY
`}</code></pre>
    <p>{`7.3 Now, let’s install the Event Streams Operator.`}</p>
    <pre><code parentName="pre" {...{}}>{`oc apply -f subscriptions/\${CP4I_VER}/05-event-streams-subscription.yaml
`}</code></pre>
    <p>{`7.4 Confirm the operator has been deployed successfully before moving to the next step running the following command.`}</p>
    <pre><code parentName="pre" {...{}}>{`SUB_NAME=$(oc get deployment eventstreams-cluster-operator -n openshift-operators --ignore-not-found -o jsonpath='{.metadata.labels.olm\\.owner}');if [ ! -z "$SUB_NAME" ]; then oc get csv/$SUB_NAME --ignore-not-found -o jsonpath='{.status.phase}';fi;echo
`}</code></pre>
    <p>{`You should get a response like this:`}</p>
    <pre><code parentName="pre" {...{}}>{`Succeeded
`}</code></pre>
    <p>{`7.5 Deploy Event Streams instance.`}</p>
    <pre><code parentName="pre" {...{}}>{`oc apply -f instances/\${CP4I_VER}/\${OCP_TYPE}/05-event-streams-instance.yaml
`}</code></pre>
    <p>{`7.6 Confirm the instance has been deployed successfully before moving to the next step running the following command.`}</p>
    <pre><code parentName="pre" {...{}}>{`oc get eventstreams es-demo -n tools -o jsonpath='{.status.phase}';echo
`}</code></pre>
    <p><inlineCode parentName="p">{`Note`}</inlineCode>{`: this will take few minutes, so be patient, and at some point you may see some errors (it is common to receive FAILED message in the first 15 minutes), but at the end (you need to wait few minutes 15/30 minutes) you should get a response like this :`}</p>
    <pre><code parentName="pre" {...{}}>{`Ready
`}</code></pre>
    <p>{`7.7 Create topics and users.`}</p>
    <pre><code parentName="pre" {...{}}>{`oc apply -f resources/02a-es-initial-config-jgr-topics.yaml
oc apply -f resources/02a-es-initial-config-jgr-users.yaml
oc apply -f resources/02a-es-initial-config-ea-topics.yaml -n tools
oc apply -f resources/02a-es-initial-config-watsonx-topics.yaml -n tools
`}</code></pre>
    <p>{`7.8 Enable Kafka Connect base.`}</p>
    <pre><code parentName="pre" {...{}}>{`scripts/08c-event-streams-kafka-connect-config.sh
`}</code></pre>
    <p>{`7.9 Confirm the instance has been deployed successfully before moving to the next step running the following command.`}</p>
    <pre><code parentName="pre" {...{}}>{`oc get kafkaconnects jgr-connect-cluster -n tools -o jsonpath='{.status.conditions[0].type}';echo
`}</code></pre>
    <p>{`Note this will take few minutes, but at the end you should get a response like this:`}</p>
    <pre><code parentName="pre" {...{}}>{`Ready
`}</code></pre>
    <p>{`7.10 Enable Kafka Connector Datagen.`}</p>
    <pre><code parentName="pre" {...{}}>{`scripts/08e-event-streams-kafka-connector-datagen-config.sh
`}</code></pre>
    <p>{`7.11 Confirm the instances has been deployed successfully before moving to the next step running the following command.`}</p>
    <pre><code parentName="pre" {...{}}>{`oc get kafkaconnector -n tools
`}</code></pre>
    <p>{`Note this will take few minutes, but at the end you should get a response like this.`}</p>
    <pre><code parentName="pre" {...{}}>{`NAME                 CLUSTER               CONNECTOR CLASS                                                         MAX TASKS   READY
kafka-datagen        jgr-connect-cluster   com.ibm.eventautomation.demos.loosehangerjeans.DatagenSourceConnector   1           True
kafka-datagen-avro   jgr-connect-cluster   com.ibm.eventautomation.demos.loosehangerjeans.DatagenSourceConnector   1           True
kafka-datagen-reg    jgr-connect-cluster   com.ibm.eventautomation.demos.loosehangerjeans.DatagenSourceConnector   1           True
`}</code></pre>
    <hr></hr>
    <h2>{`8 - Deploy Event Endpoint Management (EEM)`}</h2>
    <p>{`8.1 First, let’s intall the EEM Catalog Source.`}</p>
    <pre><code parentName="pre" {...{}}>{`oc apply -f catalog-sources/\${CP4I_VER}/13-eem-catalog-source.yaml
`}</code></pre>
    <p>{`8.2 Confirm the catalog source has been deployed successfully before moving to the next step running the following command.`}</p>
    <pre><code parentName="pre" {...{}}>{`oc get catalogsources ibm-eventendpointmanagement-catalog -n openshift-marketplace -o jsonpath='{.status.connectionState.lastObservedState}';echo
`}</code></pre>
    <p>{`You should get a response like this:`}</p>
    <pre><code parentName="pre" {...{}}>{`READY
`}</code></pre>
    <p>{`8.3 Install EEM Operator.`}</p>
    <pre><code parentName="pre" {...{}}>{`oc apply -f subscriptions/\${CP4I_VER}/09-eem-subscription.yaml
`}</code></pre>
    <p>{`8.4 Confirm the operator has been deployed successfully before moving to the next step running the following command.`}</p>
    <pre><code parentName="pre" {...{}}>{`SUB_NAME=$(oc get deployment ibm-eem-operator -n openshift-operators --ignore-not-found -o jsonpath='{.metadata.labels.olm\\.owner}');if [ ! -z "$SUB_NAME" ]; then oc get csv/$SUB_NAME --ignore-not-found -o jsonpath='{.status.phase}';fi;echo
`}</code></pre>
    <p>{`You should get a response like this:`}</p>
    <pre><code parentName="pre" {...{}}>{`Succeeded
`}</code></pre>
    <p>{`8.5 Set passwords via environment variables:`}</p>
    <pre><code parentName="pre" {...{}}>{`export EEM_ADMIN_PWD=<eem-admin-pwd>
export EEM_USER_PWD=<es-user-pwd>
`}</code></pre>
    <p>{`8.6 Deploy EEM Manager instance:`}</p>
    <pre><code parentName="pre" {...{}}>{`scripts/19a-eem-manager-inst-deploy.sh
`}</code></pre>
    <p>{`8.7 Confirm the instance has been deployed successfully before moving to the next step running the following command:`}</p>
    <pre><code parentName="pre" {...{}}>{`oc get eventendpointmanagement eem-demo-mgr -n tools -o jsonpath='{.status.phase}';echo
`}</code></pre>
    <p>{`Note this will take few minutes, so be patient, but at the end you should get a response like this:`}</p>
    <pre><code parentName="pre" {...{}}>{`Running
`}</code></pre>
    <p>{`8.8 Deploy EEM Gateway instance:`}</p>
    <pre><code parentName="pre" {...{}}>{`scripts/19b-eem-gateway-inst-deploy.sh
`}</code></pre>
    <p>{`8.9 Confirm the instance has been deployed successfully before moving to the next step running the following command.`}</p>
    <pre><code parentName="pre" {...{}}>{`oc get eventgateway eem-demo-gw -n tools -o jsonpath='{.status.phase}';echo
`}</code></pre>
    <p>{`Note this will take few minutes, so be patient, but at the end you should get a response like this:`}</p>
    <pre><code parentName="pre" {...{}}>{`Running
`}</code></pre>
    <p>{`8.10 Integrate EEM with ES instance`}</p>
    <pre><code parentName="pre" {...{}}>{`scripts/19f-eem-es-config.sh
`}</code></pre>
    <p>{`8.11 Get token for post deployment configuration.`}</p>
    <p>{`a) Log in to your Event Endpoint Management UI from a supported web browser (use the cmd  oc get eem -n tools to determine the login URL for your Event Endpoint Management instance and log in with eem-admin and the password defined earlier).`}</p>
    <p>{`b) Click the user icon in the header, and then click Profile to open the Profile page.`}</p>
    <p>{`c) Within the Profile page, click Create token to open the dialog.`}</p>
    <p>{`d) Read the message and note that API access tokens expire.`}</p>
    <p>{`e) Provide a token description that can be used to identify your token and then click Create.`}</p>
    <p>{`f) To copy the token, click Copy token.`}</p>
    <p>{`g) Click Close to close the dialog.`}</p>
    <p>{`8.12 Set environment variable for token.`}</p>
    <pre><code parentName="pre" {...{}}>{`export EEM_TOKEN=<my-eem-token>
`}</code></pre>
    <p>{`8.13 Populate EEM Catalog.`}</p>
    <pre><code parentName="pre" {...{}}>{`scripts/19e-eem-manager-config.sh
`}</code></pre>
    <hr></hr>
    <h2>{`9 - Deploy the Enterprise Messaging (MQ)`}</h2>
    <p>{`9.1 First, let’s intall the MQ Catalog Source.`}</p>
    <pre><code parentName="pre" {...{}}>{`oc apply -f catalog-sources/\${CP4I_VER}/09-mq-catalog-source.yaml
`}</code></pre>
    <p>{`9.2 Confirm the catalog source has been deployed successfully before moving to the next step running the following command.`}</p>
    <pre><code parentName="pre" {...{}}>{`oc get catalogsources ibmmq-operator-catalogsource -n openshift-marketplace -o jsonpath='{.status.connectionState.lastObservedState}';echo
`}</code></pre>
    <p>{`You should get a response like this:`}</p>
    <pre><code parentName="pre" {...{}}>{`READY
`}</code></pre>
    <p>{`9.3 Install MQ Operator.`}</p>
    <pre><code parentName="pre" {...{}}>{`oc apply -f subscriptions/\${CP4I_VER}/06-mq-subscription.yaml
`}</code></pre>
    <p>{`9.4 Confirm the operator has been deployed successfully before moving to the next step running the following command.`}</p>
    <pre><code parentName="pre" {...{}}>{`SUB_NAME=$(oc get deployment ibm-mq-operator -n openshift-operators --ignore-not-found -o jsonpath='{.metadata.labels.olm\\.owner}');if [ ! -z "$SUB_NAME" ]; then oc get csv/$SUB_NAME --ignore-not-found -o jsonpath='{.status.phase}';fi;echo
`}</code></pre>
    <p>{`You should get a response like this:`}</p>
    <pre><code parentName="pre" {...{}}>{`Succeeded
`}</code></pre>
    <p>{`9.5 Set MQ namespace environment variable.`}</p>
    <pre><code parentName="pre" {...{}}>{`export MQ_NAMESPACE=cp4i-mq
`}</code></pre>
    <p>{`9.6 Create certificates and extra route.`}</p>
    <pre><code parentName="pre" {...{}}>{`scripts/10a-qmgr-pre-config.sh
`}</code></pre>
    <p>{`9.7 Create configmap with MQ configuration.`}</p>
    <pre><code parentName="pre" {...{}}>{`oc apply -f resources/03c-qmgr-mqsc-config.yaml
`}</code></pre>
    <p>{`9.8 Deploy MQ Queue Manager instance.`}</p>
    <pre><code parentName="pre" {...{}}>{`scripts/10b-qmgr-inst-deploy.sh
`}</code></pre>
    <p>{`9.9 Confirm the instance has been deployed successfully before moving to the next step running the following command.`}</p>
    <pre><code parentName="pre" {...{}}>{`oc get queuemanager qmgr-demo -n tools -o jsonpath='{.status.phase}';echo
`}</code></pre>
    <p>{`Note this will take few minutes, but at the end you should get a response like this:`}</p>
    <pre><code parentName="pre" {...{}}>{`Running
`}</code></pre>
    <p>{`9.10 Create CCDT.`}</p>
    <pre><code parentName="pre" {...{}}>{`scripts/10c-qmgr-post-config.sh
`}</code></pre>
    <p>{`9.11 Deploy MQ Source Connector.`}</p>
    <pre><code parentName="pre" {...{}}>{`oc apply -f resources/02b-es-mq-source.yaml
`}</code></pre>
    <p>{`9.12 Deploy MQ Sink Connector.`}</p>
    <pre><code parentName="pre" {...{}}>{`oc apply -f resources/02c-es-mq-sink.yaml
`}</code></pre>
    <hr></hr>
    <h2>{`10 - Deploy Event Processing`}</h2>
    <p>{`10.1 Install Apache Flink Catalog Source.`}</p>
    <pre><code parentName="pre" {...{}}>{`oc apply -f catalog-sources/\${CP4I_VER}/14-ea-flink-catalog-source.yaml
`}</code></pre>
    <p>{`10.2 Confirm the catalog source has been deployed successfully before moving to the next step running the following command.`}</p>
    <pre><code parentName="pre" {...{}}>{`oc get catalogsources ibm-eventautomation-flink-catalog -n openshift-marketplace -o jsonpath='{.status.connectionState.lastObservedState}';echo
`}</code></pre>
    <p>{`You should get a response like this:`}</p>
    <pre><code parentName="pre" {...{}}>{`READY
`}</code></pre>
    <p>{`10.3 Install Apache Flink Operator.`}</p>
    <pre><code parentName="pre" {...{}}>{`oc apply -f subscriptions/\${CP4I_VER}/10-ea-flink-subscription.yaml
`}</code></pre>
    <p>{`10.4 Confirm the operator has been deployed successfully before moving to the next step running the following command.`}</p>
    <pre><code parentName="pre" {...{}}>{`SUB_NAME=$(oc get deployment flink-kubernetes-operator -n openshift-operators --ignore-not-found -o jsonpath='{.metadata.labels.olm\\.owner}');if [ ! -z "$SUB_NAME" ]; then oc get csv/$SUB_NAME --ignore-not-found -o jsonpath='{.status.phase}';fi;echo
`}</code></pre>
    <p>{`You should get a response like this:`}</p>
    <pre><code parentName="pre" {...{}}>{`Succeeded
`}</code></pre>
    <p>{`10.5 Prepare TrustStore for Event Automation.`}</p>
    <pre><code parentName="pre" {...{}}>{`scripts/20d-ea-truststore-config.sh
`}</code></pre>
    <p>{`10.6 Deploy Apache Flink instance.`}</p>
    <pre><code parentName="pre" {...{}}>{`oc apply -f instances/\${CP4I_VER}/common/21-ea-flink-instance.yaml
`}</code></pre>
    <p>{`10.7 Confirm the instance has been deployed successfully before moving to the next step running the following command.`}</p>
    <pre><code parentName="pre" {...{}}>{`oc get flinkdeployment ea-flink-demo -n tools -o jsonpath='{.status.jobManagerDeploymentStatus}';echo
`}</code></pre>
    <p>{`You should get a response like this:`}</p>
    <pre><code parentName="pre" {...{}}>{`READY
`}</code></pre>
    <p>{`10.8 Install Event Processing Catalog Source.`}</p>
    <pre><code parentName="pre" {...{}}>{`oc apply -f catalog-sources/\${CP4I_VER}/15-event-processing-catalog-source.yaml
`}</code></pre>
    <p>{`10.9 Confirm the catalog source has been deployed successfully before moving to the next step running the following command.`}</p>
    <pre><code parentName="pre" {...{}}>{`oc get catalogsources ibm-eventprocessing-catalog -n openshift-marketplace -o jsonpath='{.status.connectionState.lastObservedState}';echo
`}</code></pre>
    <p>{`You should get a response like this:`}</p>
    <pre><code parentName="pre" {...{}}>{`READY
`}</code></pre>
    <p>{`10.10 Install Event Processing Operator.`}</p>
    <pre><code parentName="pre" {...{}}>{`oc apply -f subscriptions/\${CP4I_VER}/11-event-processing-subscription.yaml
`}</code></pre>
    <p>{`10.11 Confirm the operator has been deployed successfully before moving to the next step running the following command.`}</p>
    <pre><code parentName="pre" {...{}}>{`SUB_NAME=$(oc get deployment ibm-ep-operator -n openshift-operators --ignore-not-found -o jsonpath='{.metadata.labels.olm\\.owner}');if [ ! -z "$SUB_NAME" ]; then oc get csv/$SUB_NAME --ignore-not-found -o jsonpath='{.status.phase}';fi;echo
`}</code></pre>
    <p>{`You should get a response like this.`}</p>
    <pre><code parentName="pre" {...{}}>{`Succeeded
`}</code></pre>
    <p>{`10.12 Set password via environment variables.`}</p>
    <pre><code parentName="pre" {...{}}>{`export EP_ADMIN_PWD=<ep-admin-pwd>
`}</code></pre>
    <p>{`10.13 Deploy Event Processing instance.`}</p>
    <pre><code parentName="pre" {...{}}>{`scripts/20b-ea-ep-inst-deploy.sh
`}</code></pre>
    <p>{`10.14 Confirm the instance has been deployed successfully before moving to the next step running the following command.`}</p>
    <pre><code parentName="pre" {...{}}>{`oc get eventprocessing ep-demo -n tools -o jsonpath='{.status.phase}';echo
`}</code></pre>
    <p>{`You should get a response like this:`}</p>
    <pre><code parentName="pre" {...{}}>{`Running
`}</code></pre>
    <p>{`10.15 Install PGSQL Operator.`}</p>
    <pre><code parentName="pre" {...{}}>{`oc apply -f resources/12a-pgsql-subscription.yaml
`}</code></pre>
    <p>{`10.16 Confirm the operator has been deployed successfully before moving to the next step running the following command.`}</p>
    <pre><code parentName="pre" {...{}}>{`SUB_NAME=$(oc get deployment pgo -n openshift-operators --ignore-not-found -o jsonpath='{.metadata.labels.olm\\.owner}');if [ ! -z "$SUB_NAME" ]; then oc get csv/$SUB_NAME --ignore-not-found -o jsonpath='{.status.phase}';fi;echo
`}</code></pre>
    <p>{`You should get a response like this:`}</p>
    <pre><code parentName="pre" {...{}}>{`Succeeded
`}</code></pre>
    <p>{`10.17 Create configmap with db configuration.`}</p>
    <pre><code parentName="pre" {...{}}>{`oc apply -f resources/12b-pgsql-config.yaml
`}</code></pre>
    <p>{`10.18 Deploy a PGSQL DB instance.`}</p>
    <pre><code parentName="pre" {...{}}>{`oc apply -f resources/12c-pgsql-db.yaml
`}</code></pre>
    <p>{`10.19 Confirm the instance has been deployed successfully before moving to the next step running the following command.`}</p>
    <pre><code parentName="pre" {...{}}>{`oc get pods -l "postgres-operator.crunchydata.com/role=master" -n tools -o jsonpath='{.items[0].status.conditions[1].status}';echo
`}</code></pre>
    <p>{`After a few minutes you should get a response like this:`}</p>
    <pre><code parentName="pre" {...{}}>{`True
`}</code></pre>
    <p>{`10.20 Get information to access EA instances.`}</p>
    <pre><code parentName="pre" {...{}}>{`scripts/20c-ea-access-info.sh
`}</code></pre>
    <hr></hr>
    <h2>{`Summary`}</h2>
    <p>{`You have successfully completed this lab. In this lab you learned:`}</p>
    <ul>
      <li parentName="ul">{`how to install and configure a basic IBM Event-led solution by deploying CP4I using command line interface from scratch.`}</li>
      <li parentName="ul">{`how to deploy vent Streams, Event Endpoint Management, Event Processing and MQ instances.`}</li>
    </ul>
    <p>{`In the `}<a href="https://yourlearning.ibm.com/activity/PLAN-85D073F5A7AA" target="_blank">{`IBM Event Automation Level 3 course`}</a>{`, you can learn how to demo the IBM Event Automation technology.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      